module.exports = __webpack_public_path__ + "img/app development.16c33405.png";